import React from 'react';
import { BadgeCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section id="guarantee" aria-labelledby="guarantee-title" className="border-b border-white/5 bg-ink-900" data-id="element-101" data-mp="1o3x23lbnuo1h">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-102" data-mp="2223kdt44mfg1">
        <div className="rounded-2xl border-2 border-brand bg-ink-800 p-8 sm:p-12" data-id="element-103" data-mp="1x3tkj57giqo3">
          <span className="inline-flex items-center gap-2 rounded-full border border-brand/40 bg-brand/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-brand" data-id="element-104" data-mp="19ehf8gf932r2">
            <BadgeCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-105" data-mp="14dtgf8ks5hma" />
            Guarantee
          </span>
          <h2 id="guarantee-title" className="mt-6 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-106" data-mp="1edu23164g9tn">
            The go-live guarantee, in writing.
          </h2>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-107" data-mp="lo4wsbmdpnm8">
            If the system is not booking qualified appointments inside your first 30 days,
            month two is free. Anchored to response time and booked appointments, never
            closings. Nobody else in this category puts it in writing.
          </p>
          <p className="mt-7 max-w-lg text-xs leading-relaxed text-white/40" data-id="element-108" data-mp="12qwrxp2itsfy">
            Guarantee window starts at completed onboarding. Typical onboarding is under 7
            business days once we have access.
          </p>
        </div>
      </div>
    </section>;
}